
import React, { useEffect, useState } from 'react';
import { Pagination } from 'antd';
import apiClient from '../../../Api/apiClient';
import { PHOTO_BASE_URL_Admin } from './../../../Api/config';
import { useNavigate } from 'react-router-dom';
import { FaAngleLeft, FaAngleRight, FaEye } from 'react-icons/fa';
import NotFoundPic from "../../../Assets/images/tenderNotFoundImage.png";
import searchIconImage from "../../../Assets/icon/freeTenderSearchIcon.png";
import addPic from "../../../Assets/images/AboutUs-unsplash_JaoVGh5aJ3E.png";
import welcomeMessage from '../../../Assets/images/welcomeMessage.png';
const FreeTenderCards = () => {
  const navigate = useNavigate();
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchKey, setSearchKey] = useState('');
  const [totalTenders, setTotalTenders] = useState(0);
  const cardsPerPage = 7;

  const [totalAdvertisements, setTotalAdvertisements] = useState([]);


  useEffect(() => {
    const fetchTenders = async () => {
      setLoading(true);
      try {
        const response = await apiClient.get(
          `/user/tender-user/free?limit=${cardsPerPage}&skip=${(currentPage - 1) * cardsPerPage}&key=${encodeURIComponent(searchKey)}`
        );

        // console.log('free tender:', response.data);
        setTenders(response.data.data);
        setTotalTenders(response.data.total);
      } catch (error) {
        console.error('Error fetching tenders:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTenders();
  }, [currentPage, searchKey]);

  const handlePageChange = page => {
    setCurrentPage(page);

    const section = document.getElementById("scroll-target");
    if (section) {
      const sectionPosition = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionPosition - 250,
        behavior: "smooth",
      });
    }
  };

  function itemRender(current, type, originalElement) {
    if (type === 'prev') {
      return <a className='flex items-center gap-1'> <FaAngleLeft /> Back</a>;
    }
    if (type === 'next') {
      return <a className='flex items-center gap-1'> Next <FaAngleRight /></a>;
    }
    return originalElement;
  }

  const handleSearchChange = event => {
    setSearchKey(event.target.value);
    setCurrentPage(1);
  };

  const handleViewDetailsClick = tenderId => {
    navigate(`/viewTenderDetails/${tenderId}`, {
      state: { FromFreeTenders: 'FromFreeTenders' },
    });
    window.scrollTo(0, 0);
  };

  const fetchAdvertisements = async () => {
    try {
      const response = await apiClient.get('/user/add', {
        params: { panel_name: 'user_panel' },
      });

      setTotalAdvertisements(response.data.data);
    } catch (error) {
      console.error("Error fetching advertisements:", error);
    }
  };

  useEffect(() => {
    fetchAdvertisements()
  }, [])


  const handleAdClicked = (link) => {
    const fullLink = /^https?:\/\//.test(link) ? link : `http://${link}`;
    window.open(fullLink, "_blank");

  };

  // Calculate the advertisements to display based on the current page
  const adsPerPage = 3;
  const startAdIndex = (currentPage - 1) * adsPerPage;
  const endAdIndex = startAdIndex + adsPerPage;
  const adsToShow = totalAdvertisements.slice(startAdIndex, endAdIndex);

  return (
    <div className="flex flex-col md:flex-row ">
      {/* Main Section */}
      <section className="bg-freeTenderColor shadow-md rounded-md md:p-4 p-1 w-full md:w-3/4">
        {/* Search & Filters */}
        {/* <div className="mb-6 text-center">
          <h2 className="text-2xl font-bold text-gray-800">Free Tenders</h2>
          <p className="text-xs text-gray-600">
            See all the tenders and details with your subscription plan
          </p>
        </div> */}
        {/* Free tender Section */}
        <section className="mb-4">
          <img src={welcomeMessage} alt="" />
        </section>

        <div className="flex md:px-7 flex-col md:flex-row justify-between items-center mb-5">
          <div className="relative flex items-center w-full sm:w-2/3 md:w-1/2 lg:w-1/3 mb-6">
            <div className="absolute left-4 md:w-10 md:h-10 w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center">
              <img src={searchIconImage} alt="Icon" className="w-4 h-4" />
            </div>
            <input
              value={searchKey}
              onChange={handleSearchChange}
              type="text"
              placeholder="Write Tender keywords"
              className="flex-1 border border-gray-300 rounded-full pl-16 pr-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-600 text-sm sm:text-base w-full"
            />
          </div>
          <p className="text-gray-500 text-sm mb-2 mr-10">
            <span className="font-semibold">{tenders.length}</span> results
            matched with your filter
          </p>
        </div>

        {/* Tenders List */}
        <div id="scroll-target">
          <div className="flex-1">
            <div className="container mx-auto ">
              <div className="my-3 flex justify-between">
                <div>
                 <h1 className='text-sm md:text-2xl ml-3 font-semibold'> All Free Tenders: <span className=' bg-red-100 rounded p-1 text-black'>
                 {totalTenders}</span></h1>
                </div>
                <Pagination
                  current={currentPage}
                  total={totalTenders}
                  pageSize={cardsPerPage}
                  onChange={handlePageChange}
                  itemRender={itemRender}
                  className="custom-pagination"
                />
              </div>

              <div className="space-y-6 mr-2">
                {tenders.length > 0 ? (
                  tenders.map((tender, index) => (
                    <React.Fragment key={tender.id}>
                      {/* Tender Card */}
                      <div className="p-2 bg-gray-50 mx-2 rounded-md space-y-3 border border-blue-700 w-full">

                        <div className="flex items-center justify-between">
                          {/* <h3 className="lg:text-lg text-sm md:text-lg font-semibold text-gray-800">
                            {tender.name}
                          </h3> */}

                          <h3 className="text-lg md:text-xl 2xl:text-2xl font-semibold text-gray-800 relative group">
                            {/* Show first 40 words and add ellipsis */}
                            <span className="line-clamp-2"><span className='text-blue-900'>Tender Title:</span> {tender.name}</span>

                    
                            {/* <span className="text-blue-500 cursor-pointer absolute bottom-0 left-0 right-0 text-xs mt-2 group-hover:block hidden">
                              See More
                            </span> */}

                            {/* Hover to show full name */}
                            <span className="absolute hidden group-hover:block bg-gray-600 text-white text-sm rounded-lg shadow-lg p-2 z-20 bottom-full mt-2  left-1/2 transform -translate-x-1/2 w-full mx-3">
                               {tender.name}
                            </span>
                          </h3>

                          <div className='flex flex-col gap-2'>
                            <div className=''>
                              <p
                                className={`text-xs text-white px-3 py-1 rounded-full ${tender.tender_status === 'live'
                                  ? 'bg-green-500'
                                  : 'bg-red-500'
                                  }`}
                              >
                                {tender.tender_status.charAt(0).toUpperCase() +
                                  tender.tender_status.slice(1)}
                              </p>
                            </div>

                            <div className="flex items-center text-gray-500 bg-red-100 px-3 py-1 rounded-md">
                              <FaEye className="mr-1" />
                              <span>{tender.total_view || 0}</span>
                            </div>
                          </div>
                        </div>


                        <div className="w-full flex flex-col lg:flex-row gap-5 justify-between items-start lg:items-center md:items-center md:text-sm text-xs md:space-y-0">
                          <div className="w-auto flex justify-start md:justify-end">
                            <img
                              src={`${PHOTO_BASE_URL_Admin}${tender.company_logo}`}
                              alt="Tender logo"
                              className="w-24 h-16 md:w-36 md:h-28 object-contain"
                            />
                          </div>

                          <div className="w-full space-y-2 text-start md:text-left">
                            <div className="flex flex-row gap-2">
                              <strong className="text-gray-600 text-nowrap">
                                Tender ID:
                              </strong>
                              <p className="text-gray-600">
                                {tender.tender_id}
                              </p>
                            </div>
                            <div className="flex flex-row gap-2">
                              <strong className="text-gray-600 text-nowrap">
                                Published date:
                              </strong>
                              <p className="text-gray-600">
                                {new Date(
                                  tender.opening_date
                                ).toLocaleDateString('en-US', {
                                  year: 'numeric',
                                  month: 'long',
                                  day: '2-digit',
                                })}{' '}
                                ({tender.publish_on_before} days ago)
                              </p>
                            </div>
                            <div className="flex flex-row gap-2">
                              <strong className="text-gray-600 text-nowrap">
                                Submission date:
                              </strong>
                              <p
                                className={`${tender.tender_status === 'live'
                                  ? 'text-green-500'
                                  : 'text-red-500'
                                  }`}
                              >
                                {new Date(
                                  tender.submission_date
                                ).toLocaleDateString('en-US', {
                                  year: 'numeric',
                                  month: 'long',
                                  day: '2-digit',
                                })}{' '}
                                {tender.tender_status === 'live' &&
                                  `(${tender.expired_after} days more)`}
                              </p>
                            </div>

                            <button
                              onClick={e => {
                                e.stopPropagation();
                                handleViewDetailsClick(tender.id);
                              }}
                              className="mt-2 border border-gray-300 text-blue-400 py-1 px-4 rounded-md hover:bg-gray-100 md:text-sm text-xs"
                            // className="mt-2 bg-gray-300 text-black hover:text-white px-3 md:px-4 py-2 rounded-md hover:bg-blue-500 md:text-sm text-xs"
                            >
                              View Details
                            </button>

                          </div>
                        </div>

                        {/* <div className="flex md:justify-center justify-start">
                          <button
                            onClick={e => {
                              e.stopPropagation();
                              handleViewDetailsClick(tender.id);
                            }}
                            className="mt-2 border border-gray-300 text-blue-400 py-1 px-4 rounded-md hover:bg-gray-100 md:text-sm text-xs"
                          // className="mt-2 bg-gray-300 text-black hover:text-white px-3 md:px-4 py-2 rounded-md hover:bg-blue-500 md:text-sm text-xs"
                          >
                            View Details
                          </button>
                        </div> */}
                      </div>

                      {/* Display advertisements in mobile view */}
                      {index % 2 === 1 &&
                        totalAdvertisements.length > 0 &&
                        (() => {
                          const sortedAds = [...totalAdvertisements].sort(
                            (a, b) => a.serial - b.serial
                          );
                          const adIndex =
                            Math.floor(index / 2) % sortedAds.length;
                          const ad = sortedAds[adIndex];

                          return ad ? (
                            <div onClick={() => handleAdClicked(ad.url_link)} className="w-full md:hidden bg-gray-200 rounded-lg shadow-md p-2 text-center">
                              <img
                                src={`${PHOTO_BASE_URL_Admin}${ad.add_file}`}
                                alt={ad.name}
                                className="w-full h-60 rounded-md object-cover"
                              />
                            </div>
                          ) : null;
                        })()}
                    </React.Fragment>
                  ))
                ) : (
                  <div className="flex justify-center items-center h-full">
                    <img
                      className="max-w-full h-full"
                      src={NotFoundPic}
                      alt="Not Found"
                    />
                  </div>
                )}
              </div>

              <div className="my-3 flex justify-center">
                <Pagination
                  current={currentPage}
                  total={totalTenders}
                  pageSize={cardsPerPage}
                  onChange={handlePageChange}
                  itemRender={itemRender}
                  className="custom-pagination"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sidebar Advertisement (Only for Large Screens) */}

      {/* <div className="hidden md:flex flex-wrap justify-between gap-4 w-full md:w-1/4">
        <div className="w-full">
          <div className="sticky top-44 bottom-4 bg-gray-200 rounded-lg shadow-md">
            {adsToShow.length > 0 ? (
              adsToShow.map((ad, index) => (
                <div className='border rounded-md my-2 border-black' key={index}>
                  <img
                    src={`${PHOTO_BASE_URL_Admin}${ad.add_file}`}
                    alt={ad.name}
                    className="w-full h-60 max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-md cover"
                  />
                </div>
              ))
            ) : null}
          </div>
        </div>
      </div> */}

      <div className="hidden md:flex flex-wrap justify-between gap-4 w-full md:w-1/4">
        <div className="w-full">
          <div className="sticky top-36 bottom-4 bg-gray-200 rounded-lg shadow-md">
            {adsToShow.length > 0
              ? adsToShow
                .sort((a, b) => a.serial - b.serial)
                .map((ad, index) => (
                  <div onClick={() => handleAdClicked(ad.url_link)}
                    className="border rounded-md my-2 border-black"
                    key={index}
                  >
                    <img
                      src={`${PHOTO_BASE_URL_Admin}${ad.add_file}`}
                      alt={ad.name}
                      className="w-full h-60 max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-md cover"
                    />
                  </div>
                ))
              : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeTenderCards;


// import React, { useEffect, useState } from 'react';
// import { Pagination } from 'antd';
// import apiClient from '../../../Api/apiClient';
// import { PHOTO_BASE_URL_Admin } from './../../../Api/config';
// import { useNavigate } from 'react-router-dom';
// import { FaAngleLeft, FaAngleRight, FaEye } from 'react-icons/fa';
// import NotFoundPic from "../../../Assets/images/tenderNotFoundImage.png";
// import searchIconImage from "../../../Assets/icon/freeTenderSearchIcon.png";
// import addPic from "../../../Assets/images/AboutUs-unsplash_JaoVGh5aJ3E.png";

// const FreeTenderCards = () => {
//   const navigate = useNavigate();
//   const [tenders, setTenders] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchKey, setSearchKey] = useState('');
//   const [totalTenders, setTotalTenders] = useState(0);
//   const cardsPerPage = 7;

//   const [totalAdvertisements, setTotalAdvertisements] = useState([]);

//   useEffect(() => {
//     const fetchTenders = async () => {
//       setLoading(true);
//       try {
//         const response = await apiClient.get(
//           `/user/tender-user/free?limit=${cardsPerPage}&skip=${(currentPage - 1) * cardsPerPage}&key=${encodeURIComponent(searchKey)}`
//         );
//         console.log('free tender:', response.data);
//         setTenders(response.data.data);
//         setTotalTenders(response.data.total);
//       } catch (error) {
//         console.error('Error fetching tenders:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTenders();
//   }, [currentPage, searchKey]);

//   const handlePageChange = page => {
//     setCurrentPage(page);

//     const section = document.getElementById("scroll-target");
//     if (section) {
//       const sectionPosition = section.getBoundingClientRect().top + window.scrollY;
//       window.scrollTo({
//         top: sectionPosition - 250,
//         behavior: "smooth",
//       });
//     }
//   };

//   const fetchAdvertisements = async () => {
//     try {
//       const response = await apiClient.get("/user/add", {
//         params: { panel_name: "user_panel" },
//       });

//       setTotalAdvertisements(response.data.data);
//     } catch (error) {
//       console.error("Error fetching advertisements:", error);
//     }
//   };

//   useEffect(() => {
//     fetchAdvertisements();
//   }, []);

//   const adsPerPage = 3; // Show 3 ads per page

//   // Calculate the ads to show based on the current page
//   const adsToShow = totalAdvertisements.slice(
//     (currentPage - 1) * adsPerPage,
//     currentPage * adsPerPage
//   );

//   const handleSearchChange = event => {
//     setSearchKey(event.target.value);
//     setCurrentPage(1);
//   };

//   const handleViewDetailsClick = tenderId => {
//     navigate(`/viewTenderDetails/${tenderId}`, {
//       state: { FromFreeTenders: 'FromFreeTenders' },
//     });
//     window.scrollTo(0, 0);
//   };

//   function itemRender(current, type, originalElement) {
//     if (type === 'prev') {
//       return <a className='flex items-center gap-1'> <FaAngleLeft /> Back</a>;
//     }
//     if (type === 'next') {
//       return <a className='flex items-center gap-1'> Next <FaAngleRight /></a>;
//     }
//     return originalElement;
//   }

//   return (
//     <div className='flex flex-col md:flex-row '>
//       {/* Main Section */}
//       <section className="bg-freeTenderColor shadow-md rounded-md md:p-4 p-1 w-full md:w-3/4 ">
//         {/* Search & Filters */}
//         <div className="mb-6 text-center">
//           <h2 className="text-2xl font-bold text-gray-800">Free Tenders</h2>
//           <p className="text-xs text-gray-600">See all the tenders and details with your subscription plan</p>
//         </div>

//         <div className="flex md:px-7 flex-col md:flex-row justify-between items-center mb-5">
//           <div className="relative flex items-center w-full sm:w-2/3 md:w-1/2 lg:w-1/3 mb-6">
//             <div className="absolute left-4 md:w-10 md:h-10 w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center">
//               <img src={searchIconImage} alt="Icon" className="w-4 h-4" />
//             </div>
//             <input
//               value={searchKey}
//               onChange={handleSearchChange}
//               type="text"
//               placeholder="Write Tender keywords"
//               className="flex-1 border border-gray-300 rounded-full pl-16 pr-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-600 text-sm sm:text-base w-full"
//             />
//           </div>
//           <p className="text-gray-500 text-sm mb-2 mr-10">
//             <span className="font-semibold">{tenders.length}</span> results matched with your filter
//           </p>
//         </div>

//         {/* Tenders List */}
//         <div id="scroll-target">
//           <div className="flex-1">
//             <div className="container mx-auto">
//               <div className="space-y-6">
//                 {tenders.length > 0 ? (
//                   tenders.map((tender, index) => (
//                     <React.Fragment key={tender.id}>
//                       {/* Tender Card */}
//                       <div className="p-2 bg-gray-50 mx-2 rounded-md space-y-3 border border-blue-700 w-full">
//                         {/* Tender card details */}
//                       </div>

//                       {index % 2 === 1 && adsToShow.length > 0 && (
//                         <div className="w-full md:hidden bg-gray-200 rounded-lg shadow-md p-2 text-center">
//                           <img
//                             src={`${PHOTO_BASE_URL_Admin}${adsToShow[index % adsToShow.length]?.add_file}`}
//                             alt="Advertisement"
//                             className="w-full h-60 rounded-md object-cover"
//                           />
//                         </div>
//                       )}
//                     </React.Fragment>
//                   ))
//                 ) : (
//                   <div className="flex justify-center items-center h-full">
//                     <img className="max-w-full h-full" src={NotFoundPic} alt="Not Found" />
//                   </div>
//                 )}
//               </div>

//               <div className="my-3 flex justify-center">
//                 <Pagination
//                   current={currentPage}
//                   total={totalTenders}
//                   pageSize={cardsPerPage}
//                   onChange={handlePageChange}
//                   itemRender={itemRender}
//                   className="custom-pagination"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Sidebar Advertisement (Only for Large Screens) */}
//       <div className="hidden md:flex flex-wrap justify-between gap-4 w-full md:w-1/4">
//         <div className="w-full">
//           <div className="sticky top-44 bottom-4 bg-gray-200 rounded-lg shadow-md">
//             {adsToShow.length > 0 && (
//               adsToShow.map((ad, index) => (
//                 <div className="border rounded-md my-2 border-black" key={index}>
//                   <img
//                     src={`${PHOTO_BASE_URL_Admin}${ad.add_file}`}
//                     alt={ad.name}
//                     className="w-full h-60 max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-md cover"
//                   />
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FreeTenderCards;





// import React, { useEffect, useState } from 'react';
// import tenderLogo from '../../../Assets/images/tenderLogo.png';
// import { Pagination } from 'antd';
// import apiClient from '../../../Api/apiClient';
// import { PHOTO_BASE_URL_Admin } from './../../../Api/config';
// import { useNavigate } from 'react-router-dom';
// const FreeTenderCards = () => {

//   const navigate = useNavigate();
//   const [tenders, setTenders] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const cardsPerPage = 3; // Limit to 3 cards per page

//   useEffect(() => {
//     // Fetch tenders on component mount
//     const fetchTenders = async () => {
//       setLoading(true);
//       try {
//         const response = await apiClient.get('/user/tender-user/free');
//         console.log(response.data.data);
//         setTenders(response.data.data); // Use 'data' from the API response
//       } catch (error) {
//         console.error('Error fetching tenders:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTenders();
//   }, []);

//   const handlePageChange = page => {
//     setCurrentPage(page);
//     window.scrollTo(0, 0);
//   };

//   // Get the tenders for the current page
//   const indexOfLastTender = currentPage * cardsPerPage;
//   const indexOfFirstTender = indexOfLastTender - cardsPerPage;
//   const currentTenders = tenders.slice(indexOfFirstTender, indexOfLastTender);

//   function itemRender(current, type, originalElement) {
//     if (type === 'prev') {
//       return <a>Previous</a>;
//     }
//     if (type === 'next') {
//       return <a>Next</a>;
//     }
//     return originalElement;
//   }

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//       const handleViewDetailsClick = tenderId => {
//         navigate(`/viewTenderDetails/${tenderId}`);
//       };

//   return (
//     <section className="bg-white shadow-md rounded-md p-8">
//       <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
//         Free Tenders
//       </h2>
//       <div className="relative flex items-center w-1/3 mb-6">
//         {/* Left-side Image Container */}
//         <div className="absolute left-4 w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center">
//           {/* <img src={searchIcon} alt="Icon" className="w-4 h-4" /> */}
//         </div>

//         {/* Search Input */}
//         <input
//           type="text"
//           placeholder="Write Tender keywords"
//           className="flex-1 border border-gray-300 rounded-full pl-16 pr-4 py-4 focus:outline-none focus:ring-2 focus:ring-blue-600"
//         />
//       </div>
//       <div className="flex gap-9">
//         <div className="container mx-auto">
//           <div className="space-y-6">
//             {currentTenders.length > 0 ? (
//               currentTenders.map(tender => (
//                 <div
//                   key={tender.id}
//                   className="p-6 bg-gray-50 mx-8 border mx-5 rounded-md shadow-md space-y-3"
//                 >
//                   <h3 className="text-lg mb-6 text-center font-semibold text-gray-800">
//                     {tender.name}
//                   </h3>
//                   <div className="w-full flex md:gap-40 text-left items-center">
//                     <div className="w-1/2 text-left">
//                       <div className="flex justify-between">
//                         <p className="text-gray-600">Tender ID:</p>
//                         <p className="text-gray-600">{tender.tender_id}</p>
//                       </div>
//                       <div className="flex justify-between">
//                         <p className="text-gray-600">Opening date:</p>
//                         <p className="text-gray-600">{tender.opening_date}</p>
//                       </div>
//                       <div className="flex justify-between">
//                         <p className="text-gray-600">Submission date:</p>
//                         <p className="text-gray-600">
//                           {tender.submission_date}
//                         </p>
//                       </div>
//                     </div>
//                     <div className="w-1/2 flex justify-end">
//                       <img
//                         src={`${PHOTO_BASE_URL_Admin}${tender.company_logo}`} // Assuming the logo is in the uploads folder
//                         alt="Tender logo"
//                         className="w-36 h-28"
//                       />
//                     </div>
//                   </div>

//                   <div className="flex justify-center">
//                     <button
//                       onClick={e => {
//                         e.stopPropagation();
//                         handleViewDetailsClick(tender.id);
//                       }}
//                       className="mt-4 bg-gray-300 text-black hover:text-white px-4 py-2 rounded-md hover:bg-blue-500"
//                     >
//                       View Details -&gt;
//                     </button>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <p>No tenders available</p>
//             )}
//           </div>

//           <div className="my-3 flex justify-center">
//             <Pagination
//               current={currentPage}
//               total={tenders.length}
//               pageSize={cardsPerPage}
//               onChange={handlePageChange}
//               itemRender={itemRender}
//             />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FreeTenderCards;

// import React from 'react';
// import BuySubscription from '../../../Assets/icon/arcticons_bestbuy.png';
// import tenderLogo from '../../../Assets/images/tenderLogo.png';
// import { Pagination } from 'antd';
// import { PHOTO_BASE_URL_Admin } from './../../../Api/config';
// const FreeTenderCards = () => {
//   function itemRender(current, type, originalElement) {
//     if (type === 'prev') {
//       return <a>Previous</a>;
//     }
//     if (type === 'next') {
//       return <a>Next</a>;
//     }
//     return originalElement;
//   }

//   return (
//     <section section className="bg-white shadow-md rounded-md p-8">
//       <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
//         Free Tenders
//       </h2>
// <div className="relative flex items-center w-1/3 mb-6">
//   {/* Left-side Image Container */}
//   {/* <div className="absolute left-4 w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center">
//     <img src={searchIcon} alt="Icon" className="w-4 h-4" />
//   </div> */}

//   {/* Search Input */}
//   {/* <input
//     type="text"
//     placeholder="Write Tender keywords"
//     className="flex-1 border border-gray-300 rounded-full pl-16 pr-4 py-4 focus:outline-none focus:ring-2 focus:ring-blue-600"
//   /> */}
// </div>

//       <div className="flex gap-9">
//         <div className="container mx-auto">
//           <div className="space-y-6  ">
//             <div className="p-6 bg-gray-50 mx-8 border mx-5 rounded-md shadow-md space-y-3">
//               <h3 className="text-lg mb-6 text-center font-semibold text-gray-800 ">
//                 Land development works along the new water transmission pipeline
//               </h3>
//               <div className="w-full flex md:gap-40 text-left items-center">
//                 <div className="w-1/2 text-left">
//                   <div className="flex justify-between">
//                     <p className="text-gray-600">Tender ID:</p>
//                     <p className="text-gray-600">102039</p>
//                   </div>
//                   <div className="flex justify-between">
//                     <p className="text-gray-600">Closing date:</p>
//                     <p className="text-gray-600">25 August 2024</p>
//                   </div>
//                   <div className="flex justify-between">
//                     <p className="text-gray-600">Region:</p>
//                     <p className="text-gray-600">Dhaka</p>
//                   </div>
//                 </div>
//                 <div className="w-1/2 flex justify-end">
//                   <img src={tenderLogo} alt="" className="w-36 h-28" />
//                 </div>
//               </div>

//               <div className="flex justify-center">
//                 <button className="mt-4 bg-gray-300 text-black px-4 py-2 rounded-md hover:bg-blue-700">
//                   View Details -&gt;
//                 </button>
//               </div>
//             </div>
//           </div>

//           <div className="my-3 flex justify-center">
//             <Pagination total={500} itemRender={itemRender} />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FreeTenderCards;
